import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Index('IDX_isDefault', ['isDefault'], {})
@Index('UK_processorType', ['processorType'], { unique: true })
@Entity('payment_processor_config')
export class PaymentProcessorConfigEntity extends BaseEntity {
	@Column('enum', {
		name: 'processorType',
		// Uniqueness is declared ONCE, by the @Index above. Repeating it as
		// `unique: true` here made TypeORM emit a SECOND unique index with a
		// generated name (IDX_98cd328412ab45f329f2927dce) alongside
		// UK_processorType — same column, same constraint, twice (PD-16021).
		// 'mock' (PD-15708 Q9) is the in-process test gateway; PaymentConfigService
		// refuses to store it on a production environment. Adding a value to a
		// MySQL enum needs a migration (sync never ALTERs): see
		// AddMockPaymentProcessorType.
		enum: ['authorize_net', 'cybersource', 'nmi', 'adyen', 'mock'],
	})
	public processorType!:
		| 'authorize_net'
		| 'cybersource'
		| 'nmi'
		| 'adyen'
		| 'mock';

	@Column('tinyint', { name: 'isDefault', default: () => "'0'" })
	public isDefault!: number;

	@Column('json', { name: 'credentials' })
	public credentials!: object;

	@Column('enum', {
		name: 'environment',
		enum: ['sandbox', 'production'],
		default: () => "'sandbox'",
	})
	public environment!: 'sandbox' | 'production';
}
